import cliovisLogo from './logos/ClioVis_logo.png';
import pinpointLogo from './logos/PinpointIrrigation_Logo.png';
import internnestLogo from './logos/InternNest_Logo.png';
import spiceabowlLogo from './logos/Spice-A-Bowl_Logo.png';
import phenomLogo from './logos/Phenom_Logo.png';
import makistryLogo from './logos/Makistry_Logo.png';
import gigaCarbonLogo from './logos/GigaCarbon_Logo.png';
import regaLogo from './logos/REGA_Logo.png';
import taciteLogo from './logos/tacite.ai_Logo.png';
import partScoutLogo from './logos/PartScout_Logo.png';
import tapeSportsLogo from './logos/TapeSports_Logo.png';

/** Fall 2025 cohort (restored from pre–Spring 2026 site data). */
export const fall2025PortfolioInfo = [
  {
    name: 'ClioVis',
    logo: cliovisLogo,
    description:
      'ClioVis enables any field to visualize connections over time, serving education, research, business, and data storytelling with collaborative timelines.',
  },
  {
    name: 'Pinpoint Irrigation',
    logo: pinpointLogo,
    description:
      'Pinpoint Irrigation offers a smart sprinkler system that uses real-time, variable spray patterns to deliver water precisely and efficiently.',
  },
  {
    name: 'InternNest',
    logo: internnestLogo,
    description:
      'InternNest helps interns find housing, roommates, or sublease their own place, making relocation easy, affordable, and flexible.',
  },
  {
    name: 'Spice-a-bowl',
    logo: spiceabowlLogo,
    description:
      "Spice-A-Bowl offers all-in-one spice cards to bring the world's flavors to every home kitchen with ease and fun.",
  },
  {
    name: 'Phenom',
    logo: phenomLogo,
    description:
      'Phenom bridges the gap between youth sports content needs and freelance creatives, delivering high-quality media through a frictionless hiring process.',
  },
  {
    name: 'Makistry',
    logo: makistryLogo,
    description:
      'AI-powered physical product design platform that democratizes and revolutionizes innovation by making design faster, easier, and smarter.',
  },
];

export const spring2026PortfolioInfo = [
  {
    name: 'GigaCarbon',
    logo: gigaCarbonLogo,
    description:
      'GigaCarbon builds audit-grade measurement infrastructure that converts real-world transport behavior into verifiable, conservative emissions data.',
  },
  {
    name: 'REGA',
    logo: regaLogo,
    description:
      'Rega is a screen time blocking app that turns everyday objects and places into physical keys for focus.',
  },
  {
    name: 'tacite.ai',
    logo: taciteLogo,
    description:
      "Tacite AI builds a private assistant for scientists, doctors, and industrial experts in high-stakes, regulated fields that turns scattered work into trustworthy answers—and preserves the hard-won tacit know-hows that usually lives only in people's heads.",
  },
  {
    name: 'Part Scout',
    logo: partScoutLogo,
    description:
      'Part Scout tells commercial auto part recyclers what parts are worth selling.',
  },
  {
    name: 'Tape Sports',
    logo: tapeSportsLogo,
    description:
      'Tape Sports is a software platform that uses computer vision, multi-camera capture, and automated editing pipelines to produce athlete-specific reels and enable scalable highlight generation.',
  },
];

const currentPortfolioInfo = spring2026PortfolioInfo;

export default currentPortfolioInfo;
